<template>
  <div class="bg-white max-w-lg my-4">
    <a-list bordered :data-source="institutionReports">
      <h3 slot="header" class="text-xl font-semibold">REPORTS</h3>
      <a-list-item slot="renderItem" slot-scope="item">
        <div class="w-full">
          <span
            @click="showReport(item.year, item.month)"
            class="cursor-pointer text-terracotta hover:underline"
          >
            {{ item.year }} - {{ item.month }}
          </span>
          <a-popconfirm
            title="Are you sure you want to delete this report?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="deleteReport(item.year, item.month)"
          >
            <a-icon
              type="delete"
              title="Delete"
              class="mx-2 float-right cursor-pointer text-red-400"
            ></a-icon>
          </a-popconfirm>
          <a-icon
            type="edit"
            title="Edit"
            class="mx-2 float-right cursor-pointer text-terracotta"
            @click="editReport(item.year, item.month)"
          ></a-icon>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    institutionId: {
      type: String,
      required: true,
    },
  },
  apollo: {
    institutionReports: {
      query: gql`
        query GetInstitutionReports($institutionId: Uuid!) {
          institutionReports(institutionId: $institutionId) {
            year
            month
          }
        }
      `,
      variables() {
        return {
          institutionId: this.institutionId,
        }
      },
    },
  },
  data() {
    return {
      institutionReports: [],
    }
  },
  methods: {
    showReport(year, month) {
      this.$emit('showReport', {
        institutionId: this.institutionId,
        year,
        month,
      })
    },
    editReport(year, month) {
      this.$emit('editReport', {
        institutionId: this.institutionId,
        year,
        month,
      })
    },
    deleteReport(year, month) {
      this.$emit('deleteReport', {
        institutionId: this.institutionId,
        year,
        month,
      })
    },
    reloadReports() {
      this.$apollo.queries.institutionReports.refetch()
    },
  },
}
</script>

<style></style>
